import cx from 'classnames';
import { FunctionComponent } from 'react';

type Props = {
    additionalClassName?: string;
    disabled?: boolean;
    /** @deprecated Use `variant` instead */
    isPrimary?: boolean;
    variant?: 'primary' | 'success' | 'secondary';
    isSubmitting?: boolean;
    onClick?: () => void;
    text: string;
    type?: 'button' | 'reset' | 'submit' | undefined;
};

const Button: FunctionComponent<Props> = ({ text, type = 'button', additionalClassName, disabled = false, isPrimary, isSubmitting = false, onClick = undefined, variant = 'primary' }) => {
    // For backward compatibility, if `isPrimary` is explicitly set to false, we won't apply the variant class. In all other cases (including when `isPrimary` is undefined), we will apply the variant class. This allows existing buttons that rely on `isPrimary` to continue working as before, while also enabling the use of the new `variant` prop for more explicit styling.
    const className = cx(['btn', { [`${additionalClassName}`]: additionalClassName ? true : false }, variant && isPrimary !== false && `btn-${variant}`]);

    if (disabled || isSubmitting) {
        return (
            <button className={className} type={type} disabled>
                {text}
            </button>
        );
    }

    return (
        <button className={className} type={type} onClick={onClick}>
            {text}
        </button>
    );
};

export default Button;
